(() => {
  const initBundle = (root) => {
    if (!root || root.dataset.bundleInitialized === 'true') return;
    root.dataset.bundleInitialized = 'true';

    const copyElement = root.querySelector('[data-bundle-copy]');
    const copy = copyElement ? JSON.parse(copyElement.textContent) : {};
    const productButtons = Array.from(root.querySelectorAll('[data-select-product]'));
    const previewButtons = Array.from(root.querySelectorAll('[data-open-preview]'));
    const selected = new Map();

    const message = root.querySelector('[data-bundle-message]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const stepTwo = root.querySelector('[data-step-two]');
    const stepThree = root.querySelector('[data-step-three]');
    const tierCards = Array.from(root.querySelectorAll('[data-tier-card]'));
    const selectionCount = root.querySelector('[data-selection-count]');
    const slots = Array.from(root.querySelectorAll('.summer-bundle__slot'));
    const summaryLabel = root.querySelector('[data-summary-label]');
    const summaryPrice = root.querySelector('[data-summary-price]');
    const summarySaving = root.querySelector('[data-summary-saving]');
    const addButton = root.querySelector('[data-add-bundle]');
    const addLabel = root.querySelector('[data-add-label]');
    const status = root.querySelector('[data-bundle-status]');
    const lightbox = root.querySelector('[data-bundle-lightbox]');
    const previewImage = root.querySelector('[data-preview-image]');
    const previewCaption = root.querySelector('[data-preview-caption]');
    const closePreviewButton = root.querySelector('[data-close-preview]');
    let lastPreviewTrigger = null;

    const tierTwoPrice = Number(root.dataset.tierTwoPrice);
    const tierThreePrice = Number(root.dataset.tierThreePrice);
    const tierTwoLabel = root.dataset.tierTwoLabel;
    const tierThreeLabel = root.dataset.tierThreeLabel;
    const upgradeLabel = root.dataset.upgradeLabel;
    const cartUrl = root.dataset.cartUrl || '/cart';

    const formatMoney = (cents) => {
      if (window.Shopify?.currency?.active === 'PKR') {
        return `Rs. ${Math.round(cents / 100).toLocaleString('en-PK')}`;
      }

      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }

      return `Rs. ${Math.round(cents / 100).toLocaleString('en-PK')}`;
    };

    const shakeTray = () => {
      root.classList.remove('is-shaking');
      window.requestAnimationFrame(() => {
        root.classList.add('is-shaking');
        window.setTimeout(() => root.classList.remove('is-shaking'), 420);
      });
    };

    const closePreview = () => {
      if (!lightbox) return;

      if (typeof lightbox.close === 'function' && lightbox.open) {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
        lastPreviewTrigger?.focus();
      }
    };

    const openPreview = (button) => {
      const src = button.dataset.previewSrc;
      if (!src || !lightbox || !previewImage) return;

      lastPreviewTrigger = button;
      previewImage.src = src;
      previewImage.alt = button.dataset.previewTitle || 'Bedsheet preview';
      if (previewCaption) previewCaption.textContent = button.dataset.previewTitle || '';

      if (typeof lightbox.showModal === 'function') {
        if (!lightbox.open) lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    };

    const getTarget = () => {
      if (selected.size === 2) {
        return { price: tierTwoPrice, label: tierTwoLabel, tier: 2 };
      }

      if (selected.size === 3) {
        return { price: tierThreePrice, label: tierThreeLabel, tier: 3 };
      }

      return null;
    };

    const getRequiredDiscount = (targetPrice) => {
      const subtotal = Array.from(selected.values()).reduce((sum, item) => sum + item.price, 0);
      return Math.max(0, subtotal - targetPrice);
    };

    const updateSlots = () => {
      const items = Array.from(selected.values());

      slots.forEach((slot, index) => {
        const item = items[index];
        slot.classList.toggle('is-filled', Boolean(item));

        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          slot.replaceChildren(image);
          slot.title = item.title;
        } else {
          slot.textContent = String(index + 1);
          slot.removeAttribute('title');
        }
      });
    };

    const update = () => {
      const count = selected.size;
      const target = getTarget();

      productButtons.forEach((button) => {
        const isSelected = selected.has(button.dataset.variantId);
        button.setAttribute('aria-pressed', String(isSelected));
        button.closest('[data-product-card]')?.classList.toggle('is-selected', isSelected);
        const label = button.querySelector('[data-select-label]');
        if (label) label.textContent = isSelected ? 'Selected — click to remove' : 'Select design';
      });

      selectionCount.textContent = `${count} of 3 selected`;
      progressFill.style.width = count === 0 ? '0%' : count === 1 ? '28%' : count === 2 ? '62%' : '100%';
      stepTwo.classList.toggle('is-active', count >= 2);
      stepThree.classList.toggle('is-active', count >= 3);
      tierCards.forEach((card) => card.classList.toggle('is-active', Number(card.dataset.tierCard) === count));

      if (count === 0) {
        message.textContent = copy.initial;
        summaryLabel.textContent = 'Choose 2 bedsheets';
        summaryPrice.textContent = '—';
        summarySaving.textContent = '';
        addLabel.textContent = 'Select 2 bedsheets';
        addButton.disabled = true;
      } else if (count === 1) {
        message.textContent = copy.oneSelected;
        summaryLabel.textContent = '1 more to unlock';
        summaryPrice.textContent = tierTwoLabel;
        summarySaving.textContent = '';
        addLabel.textContent = 'Select 1 more';
        addButton.disabled = true;
      } else if (target) {
        message.textContent = count === 2 ? copy.twoUnlocked : copy.threeUnlocked;
        summaryLabel.textContent = count === 2 ? '2-bed bundle' : 'Best-value 3-bed bundle';
        summaryPrice.textContent = target.label;

        const discount = getRequiredDiscount(target.price);
        summarySaving.textContent = discount > 0 ? `You save ${formatMoney(discount)}` : '';
        addLabel.textContent =
          count === 2 ? `Add 2 for ${target.label}` : `Add 3 for ${target.label}`;
        addButton.disabled = false;
      }

      updateSlots();
      status.textContent = '';
    };

    previewButtons.forEach((button) => {
      button.addEventListener('click', () => openPreview(button));
    });

    closePreviewButton?.addEventListener('click', closePreview);

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closePreview();
    });

    lightbox?.addEventListener('close', () => {
      previewImage?.removeAttribute('src');
      lastPreviewTrigger?.focus();
      lastPreviewTrigger = null;
    });

    productButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.variantId;

        if (selected.has(id)) {
          selected.delete(id);
          update();
          return;
        }

        if (selected.size >= 3) {
          message.textContent = copy.maxSelected;
          shakeTray();
          return;
        }

        const image = button.closest('[data-product-card]')?.querySelector('.summer-bundle__image');
        selected.set(id, {
          id: Number(id),
          price: Number(button.dataset.variantPrice),
          title: button.dataset.productTitle,
          variantTitle: button.dataset.variantTitle,
          image: image?.currentSrc || image?.src || '',
        });
        update();
      });
    });

    addButton.addEventListener('click', async () => {
      const target = getTarget();
      if (!target || addButton.disabled) return;

      addButton.disabled = true;
      addButton.classList.add('is-loading');
      addLabel.textContent = copy.adding;
      status.textContent = '';

      const bundleToken = `summer-${Date.now()}`;
      const offerName = `${target.tier} Bedsheets for ${target.label}`;
      const items = Array.from(selected.values()).map((item) => ({
        id: item.id,
        quantity: 1,
        properties: {
          'Bundle offer': offerName,
          Size: item.variantTitle,
          _bundle_group: bundleToken,
        },
      }));

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => null);
          throw new Error(error?.description || error?.message || copy.error);
        }

        // Shopify applies the configured automatic bundle discount in the cart.
        window.location.assign(cartUrl);
      } catch (error) {
        status.textContent = error.message || copy.error;
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
        addLabel.textContent =
          selected.size === 2 ? `Add 2 for ${tierTwoLabel}` : `Add 3 for ${tierThreeLabel}`;
      }
    });

    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-summer-bundle]').forEach(initBundle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
